import React from 'react';
import Link from 'next/link';

import { formatEther } from '../util';
import useRainbowBalance from '../hooks/useRainbowBalance';

const RainbowBalance = ({ price }) => {
  const rainbowBalance = useRainbowBalance();

  return (
    <>
      {rainbowBalance.current.lt(price) ? (
        <div className="alert alert-danger text-center">
          You don&lsquo;t have enough $RAINBOWS
        </div>
      ) : (
        ''
      )}
      <div>
        <strong>Wallet balance:</strong> {formatEther(rainbowBalance.current)}{' '}
        $RAINBOWS
        {/*
        <br />
        <strong>Pending balance:</strong>{' '}
        {formatEther(rainbowBalance.pending.total)} $RAINBOWS (
        <Link href="/stake">
          <a className="link-secondary">claim</a>
        </Link>
        )
        */}
        <br />
        <div className="my-2 text-muted">
          Need more $RAINBOWS?{' '}
          <a
            href="https://app.uniswap.org/#/swap?chain=mainnet&inputCurrency=ETH&outputCurrency=0x54a7cee7b02976ace1bdd4afad87273251ed34cf"
            className="link-secondary"
            target="_blank"
            rel="noreferrer"
          >
            Click here
          </a>
          .
        </div>
      </div>
    </>
  );
};

export default RainbowBalance;
